import {
  Card,
  Disclosure,
  DisclosureChevron,
  OrderLineItem,
} from 'corso-admin-ui';
import { useCurrency } from '~/hooks/useCurrency';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';

/** Lines taken off the claim since it was filed. Read only. */
export function ShippingClaimRemovedLineItems() {
  const { removedLineItems } = useShippingClaim();
  const { currencyCode } = useCurrency();

  if (removedLineItems.length === 0) return null;

  return (
    <Card>
      <Disclosure
        renderSummary={
          <Card.Line>
            <Card.Heading>Removed Line Items</Card.Heading>
            <DisclosureChevron />
          </Card.Line>
        }
      >
        <div className="mt-2 flex flex-col gap-4 pt-2">
          {removedLineItems.map((li) => (
            <OrderLineItem
              key={li.id}
              src={li.imgUrl}
              sku={li.sku}
              title={li.name}
              quantity={li.quantity}
              options={li.optionsFromPlatform}
              price={{ currencyCode, unitPrice: li.unitPrice }}
            />
          ))}
        </div>
      </Disclosure>
    </Card>
  );
}
